import { render, staticRenderFns } from "./AppHeaderLogin.vue?vue&type=template&id=084c2948"
import script from "./AppHeaderLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHeaderLogin.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports